import React from 'react';

const DashboardPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-secondary-900 mb-4">Dashboard</h1>
      <p className="text-secondary-600">Dashboard coming soon!</p>
    </div>
  );
};

export default DashboardPage; 